// extracted by mini-css-extract-plugin
export var cell = "_5v-4";
export var headerCell = "_5v-2";
export var rowHeader = "_5v-3";
export var table = "_5v-1";
export var tableContainer = "_5v-0";